export default __webpack_public_path__ + "assets/Currículo João Vitor da Silva Monteiro.c3a72fbb.pdf";